import {URL_BASE_API } from '../configs/urlConfigs';

import service from './api';

export const assUserEdit = (request) => {
    const ENDPOINT = URL_BASE_API+'user/associate-user/'+request.data;
    return service.get(ENDPOINT);  
    
}; 

export const assUserUpdate = (request) => {
    let assUserId   = request.data.get('assUserId');
    const ENDPOINT = URL_BASE_API+'user/associate-user/'+assUserId;
    request.data.delete('assUserId');

    return service.put(ENDPOINT,request.data);  
    
}; 

export const assUserDelete = (request) => {
    const ENDPOINT = URL_BASE_API+'user/associate-user/'+request.data;
    return service.delete(ENDPOINT);   
};

export const assUserActivate = (request) => {
    const ENDPOINT = URL_BASE_API+'user/associate-user-activate/';
    return service.put(ENDPOINT,request.data);   
};

export const assUserList = (request) => {
    let ENDPOINT = URL_BASE_API+'user/associate-users/';
    if(request.data!==undefined){ 
        let search   = request.data.search;
        let pageId   = request.data.page;
        let column   = request.data.column;   
        let pageSize = request.data.pageSize;   
        let affiliateId = request.data.affiliateId===undefined?'':request.data.affiliateId;
        let status = request.data.status===undefined?'':request.data.status;
        if(column||pageId||search||pageSize||affiliateId){
        ENDPOINT = URL_BASE_API+'user/associate-users/?page='+pageId+'&column='+column+'&first_name='+search+'&page_size='+pageSize+'&affiliate='+affiliateId;
        }
        if(status!==''){
            ENDPOINT = ENDPOINT + '&status='+status;
        }   
    }
    return service.get(ENDPOINT);   
};

export const assUserAdd = (request) => {
    const ENDPOINT = URL_BASE_API+'user/associate-user/';
    return service.post(ENDPOINT,request.data);   
};

export const assMuteEmail = (request) => {
    let id = request.data.id;
    let data = request.data.data;
    const ENDPOINT = URL_BASE_API+'user/asso-user-email/'+id;
    return service.put(ENDPOINT,data);   
};

export const assMutePush = (request) => {
    let id = request.data.id;
    let data = request.data.data;
    const ENDPOINT = URL_BASE_API+'user/asso-user-push/'+id;
    return service.put(ENDPOINT,data);   
};

